import React, { useEffect, useState } from 'react';
import Header from '../../dashboard/header';
import { Link } from 'react-router-dom';
import { Alert } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { BsPeople, BsPerson, BsCheck2Circle, BsDisplay, BsQuestion, BsFolder, BsGear } from 'react-icons/bs';
import { FaCheck, FaTimes, FaTrash, FaSortAmountUp, FaSortAmountDown, FaUser, FaCogs, FaTools } from 'react-icons/fa';
import Navbar from '../../dashboard/navbar';
import Sidebar from '../../dashboard/sidebar';
import axios from 'axios';
import useAuth from '../../dashboard/useAuth';

const Liste_utilisateur = ({ titre }) => {
    useAuth();
    const [utilisateurs, setUtilisateurs] = useState([]);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'id', direction: 'ascending' });
    const [message, setMessage] = useState('');
    const [showMessage, setShowMessage] = useState(false);

    // Pagination state
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10); // Nombre d'éléments par page
    const totalItems = utilisateurs.length;  // Si 'formationList' contient toutes les formations

    const location = useLocation();
    const user_id = localStorage.getItem('IDDDD');
    const [selectedUser, setSelectedUser] = useState(null); // Utilisateur sélectionné
    


    // Utilisation de useEffect pour mettre à jour le titre de la page
    useEffect(() => {
        if (user_id) {
            document.title = "eTrainApp | Liste des utilisateur"; // Définit le titre de la page
        }
    }, [user_id]);


    const fetchUtilisateurs = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_HOTE + '/liste-utilisateurs/');
            setUtilisateurs(response.data);
            setFilteredUsers(response.data);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    useEffect(() => {

        fetchUtilisateurs();
    }, []);

    useEffect(() => {
        const results = utilisateurs.filter(user =>
            user.nom.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.prenoms.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.statut.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.tel.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.profession.toLowerCase().includes(searchTerm.toLowerCase()) ||
            user.diplome.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredUsers(results);
    }, [searchTerm, utilisateurs]);

    const handleToggleStatus = async (utilisateur) => {
        try {
            // Envoyer la requête au backend pour changer le statut
            await axios.post(process.env.REACT_APP_HOTE + `/activer-utilisateur/${utilisateur.id}/`);

            // Stocker le message dans le localStorage avant l'actualisation
            const successMessage = `Statut de l'utilisateur ${utilisateur.nom} ${utilisateur.prenom} changé avec succès !`;
            localStorage.setItem('successMessage', successMessage);

            // Actualiser la page après le changement de statut
            fetchUtilisateurs();
        } catch (error) {
        }
    };

    // Utiliser useEffect pour afficher le message après l'actualisation
    useEffect(() => {
        const successMessage = localStorage.getItem('successMessage');
        if (successMessage) {
            // Afficher le message
            setMessage(successMessage);
            setShowMessage(true);

            // Effacer le message du localStorage après 7 secondes
            setTimeout(() => {
                setShowMessage(false);
                localStorage.removeItem('successMessage');
            }, 7000);
        }
    }, []); // Exécuter une seule fois lors du chargement de la page


    const handleSort = (key) => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const sortedUsers = [...filteredUsers].sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
    });

    // Pagination logic
    const indexOfLastUser = currentPage * itemsPerPage;
    const indexOfFirstUser = indexOfLastUser - itemsPerPage;
    const currentUsers = sortedUsers.slice(indexOfFirstUser, indexOfLastUser);
    const totalPages = Math.ceil(sortedUsers.length / itemsPerPage);

    const handleItemsPerPageChange = (e) => {
        setItemsPerPage(Number(e.target.value));
        setCurrentPage(1); // Réinitialiser à la première page
    };

    const handleUserSelect = (user) => {
        // Si l'utilisateur est déjà sélectionné, le désélectionner, sinon le sélectionner
        setSelectedUser(prevUser => (prevUser && prevUser.id === user.id ? null : user));
    };

    const handleActivateUser = async () => {
        if (selectedUser) {
            await handleToggleStatus(selectedUser);
            setSelectedUser(null); // Réinitialiser la sélection après l'action
        }
    };

    const handleDeleteUser = async () => {
        if (selectedUser) {
            await deleteUser(selectedUser);
            setSelectedUser(null); // Réinitialiser la sélection après l'action
        }
    };

    const deleteUser = async (utilisateur) => {
        try {
            // Envoi de la requête DELETE pour supprimer l'utilisateur
            const response = await fetch(`${process.env.REACT_APP_HOTE}/supprimer-utilisateur/${utilisateur.id}/`, {
                method: 'DELETE',
            });

            // Vérifier si la requête est réussie
            if (response.ok) {
                setMessage(`L'utilisateur ${utilisateur.nom} ${utilisateur.prenom} a été supprimé avec succès !`);
                setShowMessage(true);

                // Masquer le message après 1 seconde et recharger la page
                setTimeout(() => {
                    setShowMessage(false);
                    fetchUtilisateurs();
                }, 1000);
            } else {
                // En cas d'erreur du serveur (ex: utilisateur non trouvé)
                setMessage(`Erreur lors de la suppression de l'utilisateur ${utilisateur.nom} ${utilisateur.prenom}.`);
                setShowMessage(true);
            }
        } catch (error) {
            // Gérer les erreurs éventuelles
            setMessage('Une erreur est survenue lors de la suppression.');
            setShowMessage(true);
        }
    };

    const [accesGroupe, setAccesGroupe] = useState([]);
    const [groupeId, setGroupeId] = useState(null);
    const groupe = localStorage.getItem('groupe');
  
    const verifGroupe = async () => {
      const groupeStored = localStorage.getItem('groupe');
      const accesGroupeStored = localStorage.getItem('accesGroupe');
  
      if (groupeStored && accesGroupeStored) {
        setGroupeId(groupeStored);
        setAccesGroupe(JSON.parse(accesGroupeStored));
      } else {
        try {
          const response = await axios.get(`${process.env.REACT_APP_HOTE}/verif-groupe/${user_id}/${groupe}`);
          if (response.status === 200) {
            const data = response.data;
            setGroupeId(data.groupe);
  
            let cleanedAccessArray = [];
            if (Array.isArray(data.acces)) {
              cleanedAccessArray = data.acces.map((item) =>
                item.acces
                  ? item.acces.replace(/[\[\]']/g, '').trim().split(',').map((access) => access.trim())
                  : []
              ).flat();
  
              setAccesGroupe(cleanedAccessArray);
            }
  
            localStorage.setItem('groupe', data.groupe);
            localStorage.setItem('accesGroupe', JSON.stringify(cleanedAccessArray));
          }
        } catch (error) {
          // console.error('Erreur lors de la vérification du groupe', error);
        }
      }
    };
  
    useEffect(() => {
      if (user_id) {
        verifGroupe();
      }
    }, [user_id]);
  
    if (!accesGroupe.includes("Utilisateurs")) {
      return null;
    }


    return (
        <div id="wrapper">
            <Sidebar user_id={user_id} titre={titre} />
            <div id="page-wrapper" className="gray-bg">
                <Navbar />
                <div>
                    <div className="row wrapper border-bottom white-bg page-heading">
                        <div className="col-lg-12">
                            <h2><BsPerson size={25} className='mr-2' />Gestion des Utilisateurs</h2>
                            <small>Administration des utilisateurs.</small>

                            <small id='hbreadcrumb' className='d-flex justify-content-end'>
                                <ol className="breadcrumb custom-breadcrumb">
                                    <li className="breadcrumb-item custom-breadcrumb-item">
                                        <Link to={`/admin`}> Administration</Link>
                                    </li>
                                    <li className="breadcrumb-item custom-breadcrumb-item active">
                                        <Link to={`/Liste-utilisateur`}> Utilisateurs</Link>
                                    </li>
                                </ol>
                            </small>
                        </div>
                    </div>
                    <div className="container mt-3">
                        {showMessage && (
                            <Alert variant="success" onClose={() => setShowMessage(false)}>
                                {message}
                            </Alert>
                        )}
                        <div className="">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h5>Liste des utilisateurs</h5>
                                <div className="d-flex flex-column flex-md-row">
                                    <button
                                        onClick={handleActivateUser}
                                        disabled={!selectedUser}
                                        className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${selectedUser ? 'btn-success' : 'btn-default text-dark disabled'}`}
                                    >
                                        <FaCheck /> Activer / Désactiver
                                    </button>
                                    <button
                                        onClick={handleDeleteUser}
                                        disabled={!selectedUser}
                                        className={`btn mr-2 mb-2 mb-md-0 ms-0 ms-md-2 ${selectedUser ? 'btn-success' : 'btn-default text-dark disabled'}`}
                                    >
                                        <FaTrash /> Supprimer
                                    </button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="ibox">
                                        <div className="ibox-content">
                                            <div className="d-flex justify-content-between align-items-center mb-3">
                                                <select value={itemsPerPage} onChange={handleItemsPerPageChange} className="form-select bg-light p-1" style={{ width: 'auto', border: '1px black solid', borderRadius: '5px' }}>
                                                    <option value={5}>5</option>
                                                    <option value={10}>10</option>
                                                    <option value={20}>20</option>
                                                </select>
                                                <input
                                                    type="text"
                                                    placeholder="Rechercher..."
                                                    className="form-control w-25"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                />
                                            </div>
                                            <div className="table-responsive">
                                                <table className="footable table table-stripped footable-loaded tablet breakpoint" data-page-size="8" data-filter="#filter">
                                                    <thead>
                                                        <tr>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('nom')}>Nom et Prénoms {sortConfig.key === 'nom'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('email')}>Email {sortConfig.key === 'email'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('tel')}>Téléphone {sortConfig.key === 'tel'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('profession')}>Profession {sortConfig.key === 'profession'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('diplome')}>Diplôme {sortConfig.key === 'diplome'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('diplome')}>Dernière connexion {sortConfig.key === 'date_der_con'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                            <th className='text-secondary text-wrap d-none d-md-table-cell' onClick={() => handleSort('statut')}>Statut {sortConfig.key === 'statut'}{sortConfig.direction === 'ascending' ? <FaSortAmountUp /> : <FaSortAmountDown />}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentUsers.map((user) => (
                                                            <tr
                                                                key={user.id}
                                                                onClick={() => handleUserSelect(user)} // Sélectionner l'utilisateur lors du clic
                                                                className={`bg-white ${selectedUser && selectedUser.id === user.id ? 'bg-success text-white' : ''}`}
                                                            >
                                                                <td>
                                                                    {user.nom} {user.prenoms}
                                                                    <div className='lesInfos'>
                                                                        <small>Email : {user.email}</small><br />
                                                                        <small>Téléphone : {user.tel}</small><br />
                                                                        <small>Profession : {user.profession}</small><br />
                                                                        <small>Diplome : {user.diplome}</small><br />
                                                                        <small>Statut : {user.statut}</small>
                                                                    </div>
                                                                </td>
                                                                <td className="d-none d-md-table-cell">{user.email}</td>
                                                                <td className="d-none d-md-table-cell">{user.tel}</td>
                                                                <td className="d-none d-md-table-cell">{user.profession}</td>
                                                                <td className="d-none d-md-table-cell">{user.diplome}</td>
                                                                <td className="d-none d-md-table-cell">{user.date_der_con}</td>
                                                                <td className="d-none d-md-table-cell">{user.statut}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>

                                            <div className="d-flex justify-content-between align-items-center mt-3">
                                                <div className="dataTables_info" role="status" aria-live="polite">
                                                    {totalItems === 0
                                                        ? "Aucun élément à afficher"
                                                        : `Élément ${currentPage === 1 ? 1 : (currentPage - 1) * itemsPerPage + 1} à ${currentPage * itemsPerPage > totalItems ? totalItems : currentPage * itemsPerPage
                                                        } sur ${totalItems}`}
                                                </div>
                                                <div>
                                                    {Array.from({ length: totalPages }, (_, index) => (
                                                        <button
                                                            key={index + 1}
                                                            onClick={() => setCurrentPage(index + 1)}
                                                            className={`btn ${currentPage === index + 1 ? 'btn-default' : 'btn-light'} mx-1`}
                                                        >
                                                            {index + 1}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Liste_utilisateur;
